import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import 'react-lazy-load-image-component/src/effects/blur.css';

const LazyImage = ({ src, alt, imageData, style, StyledImage, className }) => {
  const [loading, setLoading] = useState(true);

  const image = imageData ? getImage(imageData) : src;

  const handleImageLoad = () => setLoading(false);

  const commonProps = {
    src: image,
    alt,
    className,
    style: {
      opacity: loading ? 0 : 1,
      transition: 'opacity 0.3s ease-in-out',
      ...style,
    },
  };

  return (
    <div style={{ position: 'relative', ...style }} className={className}>
      {loading && (
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#ddd',
            borderRadius: '8px',
            position: 'absolute',
            top: 0,
            left: 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
        />
      )}

      {StyledImage ? (
        <StyledImage onLoad={handleImageLoad} {...commonProps} image={image} />
      ) : imageData ? (
        <GatsbyImage onLoad={handleImageLoad} image={image} alt={alt} className={className} style={commonProps.style} />
      ) : (
        <LazyLoadImage onLoad={handleImageLoad} {...commonProps} className={className} />
      )}
    </div>
  );
};

export default LazyImage;
